import React from 'react';
import { Row, Col } from 'antd';
import ImageLoader from '../ImageLoader';

function ImageOnlyView({ hasImages, realmObjectID, realmObject }) {
  if (!hasImages) return null;
  return (
    <Row justify="center" style={{ marginTop: 16 }}>
      <Col span={24} style={{ textAlign: 'center' }}>
        <ImageLoader key={realmObjectID} realmObject={realmObject} />
      </Col>
    </Row>
  );
}

export default ImageOnlyView;
